/* eslint-disable */

import { Card, CardContent, Checkbox, Button, List, ListItem, Stack, Typography, Tabs, Tab, Box, Grid, TextField } from "@mui/material";
import Divider from '@mui/material/Divider';
import { MobXProviderContext, Observer } from "mobx-react";
import PropTypes from 'prop-types';
import React, { useEffect, useRef } from "react";
import EnviarPedidosDialog from "./enviarPedidos";
import NaoHaPedidos from "./naoHaPedidos";
import Pedido from "./pedido";
import SelecionarEntregadorDialog from "./selecionarEntregador";
import { Search } from "@mui/icons-material";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ paddingTop: 1 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function useDebounce(cb, delay) {
  const [debounceValue, setDebounceValue] = React.useState(cb);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebounceValue(cb);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [cb, delay]);
  return debounceValue;
}

function ListaPedidos(props) {
  const { mapaStore } = React.useContext(MobXProviderContext);
  const [value, setValue] = React.useState(0);
  const [filtro, setfiltro] = React.useState("");
  const [debounceVal, setDebounceVal] = React.useState("");

  const debounceValue = useDebounce(filtro, 800);

  const listaRef = useRef(null);

  useEffect(() => {
    mapaStore.setFiltro(filtro);
    mapaStore.buscarPedidos(true);
  }, [debounceValue]);

  const handleChangeFiltro = (e) => {
    setfiltro(e.target.value);
  };

  const handleKeyDownFiltro = (e) => {
    if (e.key === 'Enter') {
      const listas = [
        mapaStore.pedidosPendentes,
        mapaStore.pedidosACaminho,
        mapaStore.pedidosFinalizados,
        mapaStore.pedidosCancelados,
      ];
      const listaAtual = listas[mapaStore.tabIndex];
      if (listaAtual && listaAtual.length === 1 && !listaAtual[0].selected) {
        mapaStore.toggleSelected(listaAtual[0]);
      } else if (listaAtual && listaAtual.length > 1 && filtro.trim() !== '') {
        const exactMatch = listaAtual.find(p => p.sequenciaPdv?.toString() === filtro.trim());
        if (exactMatch && !exactMatch.selected) {
          mapaStore.toggleSelected(exactMatch);
        }
      }
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    mapaStore.setTabIndex(newValue);
  };

  useEffect(() => {
  }, []);

  useEffect(() => {
    if (listaRef.current && listaRef.current.scrollTop > 0) {
      setTimeout(() => {
        listaRef.current?.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 1000);
    }
  }, [mapaStore.pedidosACaminho]); // Dispara sempre que a lista mudar

  var height = window.innerHeight

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <div
        style={{ position: 'absolute', width: '30%', height: `${height - 160}px`, zIndex: '1000' }}
      >
        <Card style={{ height: '100%', margin: '32px', padding: 0, }}>
          <CardContent style={{ padding: 0 }}>
            <Typography gutterBottom variant="h6" component="div" style={{ marginLeft: 5, paddingTop: 10, paddingLeft: 8 }}>
              Pedidos
            </Typography>
            <Observer >{() =>
              <Tabs style={{ padding: 2 }} value={value} onChange={handleChange} aria-label="abas status pedido">
                <Tab label={`Pendentes`} iconPosition="bottom" icon={
                  <Box style={{ backgroundColor: "#8bad0d", color: "#fff", borderRadius: '16px', minWidth: '25px'}}>
                    {mapaStore.pedidosPendentes.length}
                  </Box>
                }  {...a11yProps(0)} style={{ fontSize: 14, flexDirection: 'column' }} />
                <Tab label={`A Caminho`} iconPosition="bottom" icon={
                  <Box style={{ backgroundColor: "#8bad0d", color: "#fff", borderRadius: '16px', minWidth: '25px'}}>
                    {mapaStore.pedidosACaminho.length}
                  </Box>
                } {...a11yProps(1)} style={{ fontSize: 14, flexDirection: 'column'  }} />
                <Tab label={`Entregues`} iconPosition="bottom" icon={
                  <Box style={{ backgroundColor: "#8bad0d", color: "#fff", borderRadius: '16px', minWidth: '25px'}}>
                    {mapaStore.pedidosFinalizados.length}
                  </Box>
                } {...a11yProps(2)} style={{ fontSize: 14, flexDirection: 'column'  }} />
                <Tab label={`Cancelados`} iconPosition="bottom" icon={
                  <Box style={{ backgroundColor: "#8bad0d", color: "#fff", borderRadius: '16px', minWidth: '25px'}}>
                    {mapaStore.pedidosCancelados.length}
                  </Box>
                } {...a11yProps(3)} style={{ fontSize: 14, flexDirection: 'column'  }} />
              </Tabs>
            }</Observer>

            <Observer >{() =>
              <TabPanel style={{ backgroundColor: '#eaeaea' }} value={value} index={0}>
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="stretch"
                  spacing={2}
                >
                  <Button onClick={() => mapaStore.makeRoute()}
                    disabled={!mapaStore.pedidosSelecionados ||
                      !mapaStore.pedidosSelecionados[mapaStore.tabIndex] ||
                      mapaStore.pedidosSelecionados[mapaStore.tabIndex].length < 1}>
                    Exibir rota
                  </Button>
                  <SelecionarEntregadorDialog />
                  <Button onClick={() => mapaStore.definirStatus(5)}
                    disabled={!mapaStore.pedidosSelecionados ||
                      !mapaStore.pedidosSelecionados[mapaStore.tabIndex] ||
                      mapaStore.pedidosSelecionados[mapaStore.tabIndex].length < 1}>
                    Finalizar pedidos
                  </Button>
                  {/* <EnviarPedidosDialog /> */}
                </Stack>

                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="stretch"
                  spacing={1}
                  paddingLeft={3}
                  paddingRight={3}
                >
                  <Card style={{ width: '100%' }}>
                    <Stack direction="row" paddingLeft={1}
                      paddingBottom={1}>
                      <TextField fullWidth id="outlined-basic" label="Filtrar" variant="standard" type="text" value={filtro} onChange={handleChangeFiltro} onKeyDown={handleKeyDownFiltro} />
                      <Search sx={{ color: 'action.active', mt: 1.8, mx: 1 }} />
                    </Stack>
                  </Card>
                </Stack>

                <List ref={listaRef} sx={{ backgroundColor: '#eaeaea', width: '100%', maxHeight: height - 310, overflow: 'auto', paddingTop: 1 }}>
                  {mapaStore.pedidosPendentes.length > 0 ? mapaStore.pedidosPendentes.map((pedido) => (
                    <ListItem key={pedido.id}>
                      <Pedido pedido={pedido} />
                    </ListItem>
                  )) : <NaoHaPedidos />}
                </List>

              </TabPanel>
            }</Observer>


            <Observer >{() =>
              <TabPanel style={{ backgroundColor: '#eaeaea' }} value={value} index={1}>
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="stretch"
                  spacing={1}
                >
                  <Button onClick={() => mapaStore.definirStatus(0)}
                    disabled={!mapaStore.pedidosSelecionados ||
                      !mapaStore.pedidosSelecionados[mapaStore.tabIndex] ||
                      mapaStore.pedidosSelecionados[mapaStore.tabIndex].length < 1}>
                    Cancelar Entrega
                  </Button>
                  <Button onClick={() => mapaStore.definirStatus(5)}
                    disabled={!mapaStore.pedidosSelecionados ||
                      !mapaStore.pedidosSelecionados[mapaStore.tabIndex] ||
                      mapaStore.pedidosSelecionados[mapaStore.tabIndex].length < 1}>
                    Finalizar pedidos
                  </Button>

                </Stack>

                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="stretch"
                  spacing={1}
                  paddingLeft={3}
                  paddingRight={3}
                >
                  <Card style={{ width: '100%' }}>
                    <Stack direction="row" paddingLeft={1}
                      paddingBottom={1}>
                      <TextField fullWidth id="outlined-basic" label="Filtrar" variant="standard" type="text" value={filtro} onChange={handleChangeFiltro} onKeyDown={handleKeyDownFiltro} />
                      <Search sx={{ color: 'action.active', mt: 1.8, mx: 1 }} />
                    </Stack>
                  </Card>
                </Stack>

                <List ref={listaRef} sx={{ backgroundColor: '#eaeaea', width: '100%', maxHeight: height - 310, overflow: 'auto', paddingTop: 1 }}>
                  {mapaStore.pedidosACaminho.length > 0 ? mapaStore.pedidosACaminho.map((pedido) => (
                    <ListItem key={pedido.id}>
                      <Pedido pedido={pedido} />
                    </ListItem>
                  )) : <NaoHaPedidos />}
                </List>

              </TabPanel>
            }</Observer>


            <Observer >{() =>
              <TabPanel style={{ backgroundColor: '#eaeaea' }} value={value} index={2}>
                <List ref={listaRef} sx={{ backgroundColor: '#eaeaea', width: '100%', maxHeight: height - 220, overflow: 'auto', paddingTop: 1 }}>
                  <Stack
                    direction="row"
                    justifyContent="center"
                    alignItems="stretch"
                    spacing={1}
                    paddingLeft={3}
                    paddingRight={3}
                  >
                    <Card style={{ width: '100%' }}>
                      <Stack direction="row" paddingLeft={1}
                        paddingBottom={1}>
                        <TextField fullWidth id="outlined-basic" label="Filtrar" variant="standard" type="text" value={filtro} onChange={handleChangeFiltro} onKeyDown={handleKeyDownFiltro} />
                        <Search sx={{ color: 'action.active', mt: 1.8, mx: 1 }} />
                      </Stack>
                    </Card>
                  </Stack>

                  {mapaStore.pedidosFinalizados.length > 0 ? mapaStore.pedidosFinalizados.map((pedido) => (
                    <ListItem key={pedido.id}>
                      <Pedido pedido={pedido} />
                    </ListItem>
                  )) : <NaoHaPedidos />}
                </List>
              </TabPanel>
            }</Observer>


            <Observer >{() =>
              <TabPanel style={{ backgroundColor: '#eaeaea' }} value={value} index={3}>
                <List ref={listaRef} sx={{ backgroundColor: '#eaeaea', width: '100%', maxHeight: height - 265, overflow: 'auto', paddingTop: 1 }}>
                  <Stack
                    direction="row"
                    justifyContent="center"
                    alignItems="stretch"
                    spacing={1}
                    paddingLeft={3}
                    paddingRight={3}
                  >
                    <Card style={{ width: '100%' }}>
                      <Stack direction="row" paddingLeft={1}
                        paddingBottom={1}>
                        <TextField fullWidth id="outlined-basic" label="Filtrar" variant="standard" type="text" value={filtro} onChange={handleChangeFiltro} onKeyDown={handleKeyDownFiltro} />
                        <Search sx={{ color: 'action.active', mt: 1.8, mx: 1 }} />
                      </Stack>
                    </Card>
                  </Stack>

                  {mapaStore.pedidosCancelados.length > 0 ? mapaStore.pedidosCancelados.map((pedido) => (
                    <ListItem key={pedido.id}>
                      <Pedido pedido={pedido} />
                    </ListItem>
                  )) : <NaoHaPedidos />}
                </List>
              </TabPanel>
            }</Observer>

            <div style={{ height: '100vh', backgroundColor: "#eaeaea" }}></div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default ListaPedidos;
